<template>
  <!-- Main Site Navbar -->
  <nav
    id="main_nav"
    v-if="activeView != 'personas' && activeView != 'persona-detail'"
    class="navbar navbar-dark bg-dark fixed-top navbar-expand-md py-xs-2 py-0 pl-3"
    role="navigation"
  >    
    <a class="navbar-brand" href="/">
      <span v-html="'&nbsp;'"></span>
    </a>

    <!-- mobile menu icon -->
    <button type="button" class="navbar-toggler height-50" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- /mobile menu icon -->

    <div id="navbar" class="navbar-collapse collapse fade-in">
      <ul
        v-cloak
        id="main_app_nav"
        class="navbar-nav mt-0">
        
        <template v-if="isMain" >
          <li v-if="activeView!='detail'" class="nav-item" :class="{'active': activeView == 'search'}">
            <router-link to="/search" id="mnuSearch" class="nav-link manage-forms-link align-middle">Records Search</router-link>
          </li>
          <li v-if="activeView=='detail'" class="nav-item" :class="{'active': activeView == 'search'}">
            <a href="#" id="mnuSearch" @click="setActiveView('search')" class="nav-link manage-forms-link align-middle">Records Search</a>
          </li>
          <li v-if="privs.CL && allowSubscriberLookup" class="nav-item" :class="{'active': activeView == 'lookup'}">
            <router-link to="/lookup" id="mnuLookup" class="nav-link manage-forms-link align-middle">Subscriber Lookup</router-link>
          </li>
          <li v-if="allowPersonas" class="nav-item" :class="{'active': activeView == 'personas'}">
            <router-link to="/personas" id="mnuPersonas" class="nav-link manage-forms-link align-middle">Personas</router-link>
          </li>
        </template>
        <template v-else>
          <li class="nav-item">
            <a href="/" id="mnuSearch" class="nav-link manage-forms-link align-middle">Records Search</a>
          </li>
          <li class="nav-item">
            <a href="/#/lookup" id="mnuLookup" class="nav-link manage-forms-link align-middle">Subscriber Lookup</a>
          </li>
        </template>
      </ul>

      <div v-cloak class="mr-auto">
          <div v-if="showSubAccounts && subAccounts && subAccounts.length > 1" class="container btn-group d-block d-sm-none ">
            <button
              id="btnSubaccountsSmall"
              class="form-control btn btn-secondary btn-sm d-block dropdown-toggle"
              data-loading-text="..."
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{activeSubAccountDisplayName}}
            </button>
            <ul id="listSubAccounts" class="dropdown-menu">
              <li class="dropdown-header">Choose Source</li>
              <li role="separator" class="dropdown-divider"></li>
              <li class="dropdown-item"
                @click.prevent="setActiveSubAccount(null);"
                >All sources</li>
              <li role="separator" class="dropdown-divider"></li>
              <template
                v-for="(subAccount,idx) in subAccounts">
                <li
                  v-if="!subAccount.disabled"
                  class="dropdown-item"
                  @click.prevent="setActiveSubAccount(subAccount)"
                  :class="{'active': activeSubAccount && activeSubAccount.id == subAccount.id}"
                >
                  {{subAccount.sub_account_display_name}}
                </li>
              </template>
            </ul>
          </div>
          <div v-cloak v-if="showSubAccounts && subAccounts && subAccounts.length > 1" class="btn-group ml-md-3 mt-lg-0 d-none d-sm-block">
            <button
              id="btnSubaccounts"
              class="btn btn-nav-pill btn-sm dropdown-toggle"
              data-loading-text="..."
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{activeSubAccountDisplayName}}
            </button>
            <ul class="dropdown-menu">
              <li class="dropdown-header">Choose Source</li>
              <li role="separator" class="dropdown-divider"></li>
              <li class="dropdown-item"
                @click.prevent="setActiveSubAccount(null)"
                :class="{'active': !(activeSubAccount)}"
                >All sources</li>
              <li role="separator" class="dropdown-divider"></li>
              <template
                v-for="(subAccount,idx) in subAccounts"
              >
                <li
                  v-if="!subAccount.disabled"
                  class="dropdown-item"
                  @click.prevent="setActiveSubAccount(subAccount)"
                  :class="{'active': (activeSubAccount) && activeSubAccount.id == subAccount.id}"
                >
                  {{subAccount.sub_account_display_name}}
                </li>
              </template>
            </ul>

          </div>
        </div>

        <div class="navbar-nav dropdown navbar-right d-none d-sm-block" style="position: relative;">
          <button v-if="$route.name=='profile'" 
            @click.prevent="addAccount()" 
            class="btn btn-primary btn-sm mr-4" :disabled="false"><span class="glyphicons glyphicons-plus-sign"></span>&nbsp;Add Account</button>

          <a id="profileLink" class="mr-2" href="#"
            data-toggle="dropdown"
            ><svg class="align-middle" width="24" height="24" fill="currentColor" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"><g> <g>   <path d="M256,0C114.844,0,0,114.844,0,256s114.844,256,256,256s256-114.844,256-256S397.156,0,256,0z M256,74.667      c67.635,0,122.667,55.031,122.667,122.667S323.635,320,256,320s-122.667-55.031-122.667-122.667S188.365,74.667,256,74.667z      M256,469.333c-69.707,0-131.52-33.755-170.473-85.615c42.676-20.534,103.621-42.385,170.473-42.385      c66.857,0,127.807,21.854,170.474,42.383C387.521,435.577,325.708,469.333,256,469.333z"/> </g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></a>
              <div id="profileMenu" class="dropdown-menu dropdown-menu-right">
                <p class="px-4 pt-2 text-secondary font-weight-light">{{userInfo.first_name + " " + userInfo.last_name}}<br>
                  <span class="small font-weight-light text-secondary">{{userInfo.email}}</span>
                </p>
                <a href="/admin/#/profile" class="dropdown-item">
                  <span class="glyphicons glyphicons-user mr-1"></span> Profile <small>&amp;</small> Settings
                </a>

                <!--<template v-if="privs.AA || privs.AO || privs.AU">
                  <a href="/admin/#/accounts" class="dropdown-item" v-if="privs.AO || privs.AA">
                    <span class="glyphicons glyphicons-settings mr-1"></span> Account Settings
                  </a>
                </template>-->
                <div role="separator" class="dropdown-divider"></div>
                <template v-if="uiConfig && uiConfig.privs && uiConfig.privs.AO">
                  <a href="#" class="dropdown-item" @click.prevent="switchAccounts()">
                    <span class="glyphicons glyphicons-random mr-1"></span>Switch Accounts
                  </a>
                  <div role="separator" class="dropdown-divider"></div>
                </template>
                <template v-if="privs.AA">
                  <a href="/reports" class="dropdown-item">
                    <span class="glyphicons glyphicons-table mr-1"></span> Reports
                  </a>
                  <div role="separator" class="dropdown-divider"></div>
                </template>
                <a href="#" @click.prevent="showResourceCenter()" target="_blank" class="dropdown-item">
                  <span class="glyphicons glyphicons-question-sign mr-1"></span> Help <small>&amp;</small> Resources
                </a>
                <a v-if="privs.AU" href="https://archiver-docs.sageflo.com/collection/14-api" target="_blank" class="dropdown-item">
                  <span class="glyphicons glyphicons-cloud mr-1"></span> API Guide
                </a>
                <div role="separator" class="dropdown-divider"></div>
                <template v-if="(uiConfig) && (uiConfig.settings)">
                  <template v-for="(guide,index) in uiConfig.settings.usage_guides">
                    <a v-bind:href="guide.url" download class="dropdown-item">
                      <span class="glyphicons" v-bind:class="[guide.css_class]"></span> {{guide.caption}}
                    </a>
                    <div v-if="(index+1 == uiConfig.settings.usage_guides.length)" role="separator" class="dropown-divider"></div>
                  </template>
                </template>
                <div v-show="privs.EC" role="separator" class="dropdown-divider"></div>
                <a href="/api/v1/logout" class="dropdown-item"><span class="glyphicons glyphicons-exit mr-1"></span> Log Out </a>
            </div>
        </div>

    </div>
  </nav>
  <!-- /Main Site Navbar -->
  <!-- Persona Navbar -->
</template>

<script>
import {mapState} from 'vuex'

export default {
  components: {
  },
  props: {
    showSubAccounts: {
      type: Boolean,
      default: true
    },
    allowSwitch: {
      type: Boolean,
      default: false
    },
    allowEvents: {
      type: Boolean,
      default: false
    },
    isMain:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      showV2: true
    }
  },
  mounted: function() {
    
  },
  watch: {
    $route(to, from) {
      if (to.name=='lookup' && this.activeSubAccount && !this.activeSubAccount.can_profile_lookup) {
        // if changing to subscriber lookup page and active sub account is not lookup-able, set to "All" subaccounts
        this.$eventBus.$emit("showStatus",{
          msg: `<br>The <b>${this.activeSubAccountDisplayName}</b> source cannot lookup subscriber status.<br><br>
                Your options have been updated to include all sources with subscriber status capability.`,
          title: `Showing All Subaccounts`,
        });

        this.setActiveSubAccount(null)

      }
    }
  },
  computed: {
    ...mapState({
      activeView: (state)=>state.ui.activeView,
      allowSubscriberLookup: (state)=>state.user.allowSubscriberLookup,
      privs: (state)=>state.user.privs,
      uiConfig: (state)=>{
        if (state.admin ) return state.admin.uiConfig;
        else return state.user.uiConfig;
      },
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      userInfo: (state)=>state.user.userInfo,
    }),
    subAccounts: function(){
      if (this.$route.name == 'lookup') {
        return this.uiConfig.sub_accounts.filter(itm => {
          return itm.can_profile_lookup
        })
      } else {
        return this.uiConfig.sub_accounts;  
      }      
    },
    activeSubAccountDisplayName: function() {
      return (this.activeSubAccount)? this.activeSubAccount.sub_account_display_name : 'All sources';
    },
    allowPersonas: function() {
      return (this.privs && this.privs.SP && this.uiConfig.account 
        && !this.uiConfig.account.config.personas_disabled);
    },
  },
  created: function(){
    this.$store.dispatch("fetchUserInfo")
  },
  methods: {
    showResourceCenter(){
      window.pendo.BuildingBlocks.BuildingBlockResourceCenter.getResourceCenter().show()
    },
    setActiveView(name){
      this.$store.commit("setActiveView",name);      
    },    
    switchAccounts() {
      this.$parent.switchAccounts();
    },
    setActiveSubAccount(subAccount){
      this.$store.commit("setActiveSubAccount",subAccount);
    },
  },
}
</script>

<style scoped>

  .btn-nav-pill {
    background-color: rgba(0,0,0,.55);
    color:  var(--white);
    border-radius: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    border-top: 1px solid rgba(255,255,255,.18);
    border-left: 1px solid rgba(255,255,255,.18);
    border-bottom:  1px solid rgba(255,255,255,.32);
    border-right:  1px solid rgba(255,255,255,.32);
  }

  #profileLink {
    color:  var(--light);
  }

  #profileLink:hover {
    color: var(--teal);
  }
</style>
